(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

var includes = require('lodash/includes');
var startsWith = require('lodash/startsWith');
var endsWith = require('lodash/endsWith');
var isBoolean = require('lodash/isBoolean');
var isEmpty = require('lodash/isEmpty');
var isNumber = require('lodash/isNumber');

// Function Expressions

function ENDS_WITH(left, right) {
  return endsWith(left, right);
}

function CONTAINS(left, right) {
  return includes(left, right);
}

function IN(left, right) {
  return includes(right, left);
}

function STARTS_WITH(left, right) {
  return startsWith(left, right);
}

// Unary Function Expressions

function IS_EMPTY(argument) {
  return isNumber(argument) ? !argument : isEmpty(argument);
}

function IS_EMPTY2(argument) {
  if (isNumber(argument)) {
    return isNaN(argument) || !isFinite(argument);
  }
  if (isBoolean(argument)) {
    return false;
  }
  return isEmpty(argument);
}

module.exports.CONTAINS = CONTAINS;
module.exports.ENDS_WITH = ENDS_WITH;
module.exports.IN = IN;
module.exports.IS_EMPTY = IS_EMPTY;
module.exports.IS_EMPTY2 = IS_EMPTY2;
module.exports.STARTS_WITH = STARTS_WITH;

})));
//# sourceMappingURL=function.js.map
